<template>
  <div>
    <b-card no-body class="p-4">
      <div
        v-for="(item, index) in discussion"
        :key="'item-' + index"
        :item="item"
      >
        <div class="mt-2">
          <p class="text-muted text-base font-semibold">
            {{ item.postDescription }}
          </p>
        </div>
        <div class="mt-2">
          <p class=" text-sm font-normal leading-6">
            {{ item.discussDescription }}
          </p>
        </div>
        <div class="cust-bgededed p-4 my-4">
          <div class=" ">
            <p class="text-base font-semibold cust-botbor">Discussion</p>
          </div>
        </div>

        <div
          class="comments"
          v-for="(item, index) in comment"
          :key="'item-' + index"
          :item="item"
        >
          <div class="flex items-center">
            <img alt="user" class="w-9 rounded-full" :src="item.userImg" />
            <p class="font-normal text-sm ml-4">
              {{ item.userName }}
              <span class="text-gray-300 ml-2">4 minute ago</span>
            </p>
          </div>

          <div class="mt-2">
            <p class=" text-sm font-normal leading-6">
              {{ item.discussDescription }}
            </p>
          </div>
          <div class="flex items-center mt-2">
            <feather-icon
              icon="ThumbsUpIcon"
              class="cursor-pointer  mr-2 "
              svgClasses="w-4"
            ></feather-icon>
            <span class="text-grey-400">{{ item.likes }}</span>
          </div>
          <div class="cust-divider my-4"></div>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      discussion: [
        {
          postDescription:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          discussDescription:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        }
      ],
      comment: [
        {
          userImg:
            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
          userName: "John Doe",
          postDescription:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          discussDescription:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          likes: "1.2k"
        },
        {
          userImg:
            "https://demos.creative-tim.com/argon-dashboard-pro/assets/img/theme/team-4.jpg",
          userName: "Marshal Boy",
          postDescription:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          discussDescription:
            "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
          likes: "1.2k"
        }
      ]
    };
  }
};
</script>
<style>
.cust-botbor {
  border-bottom: 2px solid #2dce89;
  max-width: 15%;
}
</style>
